/*
 * Copyright (c) Worldline 2023.
 */

export const EvidenceContentType = {
    SINGLE: 'SINGLE',
    NAMED_PARTS: 'NAMED_PARTS',
    MULTI: 'MULTI',
    FORM: 'FORM'
}